// extracted by mini-css-extract-plugin
module.exports = {"suggestion":"suggestion-renderer_suggestion__QJDcp"};